export default [
  {
    path: '/employee-centre',
    component: () => import('@/layouts/GeneralLayout.vue'),
    children: [
      {
        path: 'employees',
        name: 'employees',
        component: () => import('@/views/employee-centre/employees/Index.vue'),
        meta: {
          redirectIfGuest: true,
          resource: 'employee-centre',
          action: 'access-employees',
        },
      },
      {
        path: 'employees/:id',
        name: 'employee-detail',
        component: () => import('@/views/employee-centre/employees/Detail.vue'),
        meta: {
          redirectIfGuest: true,
          resource: 'employee-centre',
          action: 'access-employees',
        },
      },
      {
        path: 'departments',
        name: 'departments',
        component: () => import('@/views/employee-centre/departments/Index.vue'),
        meta: {
          redirectIfGuest: true,
          resource: 'employee-centre',
          action: 'access-departments',
        },
      },
    ],
  },
]
